module.exports = __webpack_public_path__ + "blue_file.55bffc03.svg";